export default __webpack_public_path__ + "188c2ca6aa8c7639b9b3bacdd35c6688.svg";